<div fxLayout="row" class="snack-container">
    <div class="snack-icon snack-icon-{{getIcon}}">
        <mat-icon>{{getIcon}}</mat-icon>
    </div>
    <div class="snack-message">
        <span>{{data.message}}</span>
    </div>
</div>